 const products = [
    {
      id: 1,
      title: "Aluminum Shower Cubicles",
      price: "KSh 15,000",
      originalPrice: "KSh 18,000",
      desc: "High-quality aluminum windows with excellent durability and modern design.",
      image: "/images/shower_cabinets.jpeg",
      rating: 4.8,
      reviews: 124,
      category: "sanitary ware",
      inStock: true,
    },
    {
      id: 2,
      title: "Concrete Blocks",
      price: "KSh 45",
      originalPrice: "KSh 50",
      desc: "Standard concrete blocks perfect for construction projects.",
      image: "/images/concrete_blocks.jpeg",
      rating: 4.6,
      reviews: 89,
      category: "materials",
      inStock: true,
    },
    {
      id: 3,
      title: "Paving Blocks",
      price: "KSh 120",
      originalPrice: "KSh 140",
      desc: "Decorative paving blocks for driveways and walkways.",
      image: "/images/paving_blocks.jpeg",
      rating: 4.7,
      reviews: 67,
      category: "materials",
      inStock: true,
    },
    {
      id: 4,
      title: " Brick slips/ wall tiles",
      price: "KSh 80",
      originalPrice: "KSh 95",
      desc: "Traditional brick tiles for authentic construction look.",
      image: "/images/brickslip.jpg",
      rating: 4.5,
      reviews: 45,
      category: "materials",
      inStock: false,
    },
    {
      id: 5,
      title: "Retaining  wall concrete blocks",
      price: "KSh 25,000",
      originalPrice: "KSh 30,000",
      desc: "Premium aluminum doors with security features.",
      image: "/images/retaining_concrete.jpeg",
      rating: 4.9,
      reviews: 156,
      category: "Doors",
      inStock: true,
    },
    {
      id: 6,
      title: "Natural cladding stones",
      price: "KSh 8,500",
      originalPrice: "KSh 10,000",
      desc: "Heavy-duty steel frames for structural support.",
      image: "/images/cladding_foreman.jpeg",
      rating: 4.4,
      reviews: 78,
      category: "materials",
      inStock: true,
    },
  ];

  export default products